import React from "react";

import "./styles.scss";

export interface IToggleSwitchProps {
  checked: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  onChange: (checked: boolean) => void;
}

export const ToggleSwitch: React.FunctionComponent<IToggleSwitchProps> = ({
  checked,
  disabled,
  ariaLabel,
  onChange,
}) => {
  return (
    <label className={`toggle-switch ${disabled ? "is-disabled" : ""}`}>
      <input
        type="checkbox"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="toggle-switch-track" />
    </label>
  );
};

export default ToggleSwitch;
